const sections = document.getElementsByClassName('m-tab-content-mobile');
const mastHead = document.querySelector('.m-masthead');
class MobileTabContent {
  constructor(container) {
    this.container = container;
    this.build();
    this.addEventListeners();
  }

  build() {
    const { container } = this;

    this.rows = container.getElementsByClassName('m-tab-content-mobile__row');
    this.activeRow = null;
  }

  addEventListeners() {
    const { rows } = this;

    [].map.call(rows, row => row.addEventListener('click', this.handleRowClick.bind(this)));
  }

  handleRowClick({ currentTarget }) {
    currentTarget.classList.toggle('is-open');
  }
}

function initMobileTabContents() {
  [].map.call(sections, section => new MobileTabContent(section));
}

if (mastHead && sections) initMobileTabContents();
